import template from './illionAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            template,
            locals: {},
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.userKey = '';
              self.password = '';
              self.subscriberId = '';
              self.confirm = () => {
                $mdDialog.hide({
                  userKey: self.userKey,
                  password: self.password,
                  subscriberId: self.subscriberId
                });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
